var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CommonPagesMainContainer',[_c('CommonPagesLogo'),_c('CommonPagesGreeting'),_c('CommonPagesFormCard',[_c('Spinner',{attrs:{"isLoading":_vm.isLoading}},[_c('CommonPagesForm',{attrs:{"header":null,"message":_vm.errorMessage}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }